import {useEffect, useState} from 'react'
import {Stack} from 'react-bootstrap'
import {useCSVReader} from 'react-papaparse'
import uploadIcon from '../../../_metronic/images/FileUpload.svg'
import uuid from 'react-uuid'
import {State} from 'country-state-city'

type UploadUtilityCSVProps = {
  btnDisabled?: boolean
  setBtnDisabled?: any
  fileUploadErr: boolean
  setFileUploadErr: any
  setManualDisable?: any
  arrayHelpers: any
  setUtilityData: any
  originalutilityData: any
}

const UploadUtilityCSV = ({
  btnDisabled,
  setBtnDisabled,
  fileUploadErr,
  setFileUploadErr,
  setManualDisable,
  arrayHelpers,
  setUtilityData,
  originalutilityData,
}: UploadUtilityCSVProps) => {
  const [csvValidationMsg, setCsvValidationMsg] = useState<string>('')
  const [validationMsg, setValidationMsg] = useState<string>('')
  const [uploadingMessage, setUploadingMessage] = useState(false)
  const {CSVReader} = useCSVReader()
  const [state, setState] = useState<{id: string; value: string}[]>([])

  useEffect(() => {
    const getAllStates = State.getStatesOfCountry('US')
    setState(getAllStates.map((eachState) => ({id: eachState.isoCode, value: eachState.name})))
  }, [])
  return (
    <div className='upload-section'>
      <CSVReader
        maxFiles={1}
        accept='.csv'
        onUploadAccepted={async (results: any) => {
          console.log('CSV Upload Results:', results)
          let canUpload = true
          setValidationMsg('')
          setManualDisable && setManualDisable(true)
          if (results.data.length === 0) {
            setBtnDisabled && setBtnDisabled(true)
            setValidationMsg('Please upload valid data')
            canUpload = false
          }

          const expectedHeaders = [
            'Utility',
            'Utility Pronunciation',
            'Utility Name',
            'Utility DUNS Number',
            'Submit Days',
            'Utility Phone Number',
            'UAN Validation',
            'UAN Regex',
            'UAN Regex Message',
            'Meter ID Regex',
            'Meter ID Regex Message',
            'Utility State',
            'Zip Code',
          ]
          const requiredColumns = [
            'Utility',
            'Utility Pronunciation',
            'Utility DUNS Number',
          ]

          const convertToUtilityDataFormat = (item: any) => {
            return {
              value: item?.Utility,
              utilityDunsNumber: item?.['Utility DUNS Number'],
              utilitySubmitDays: item?.['Submit Days'],
              utilityShortName: item?.['Utility Pronunciation']?.split(' ').join(' '),
              utilityName: item?.['Utility Name'],
              utilityPhoneNumber: item?.['Utility Phone Number'],
              uanValidation: item?.['UAN Validation'],
              regexValidation: item?.['UAN Regex'],
              regexValidationMessage: item?.['UAN Regex Message'],
              meterRegexValidation: item?.['Meter ID'],
              meterRegexValidationMessage: item?.['Meter ID Message'],
              utilityState: (() => {
                const matchedState = state.find(
                  (state) => state.value.toLowerCase() === item?.['Utility State'].toLowerCase()
                )
                if (matchedState) {
                  return matchedState.value
                } else {
                  return item?.['Utility State']
                }
              })(),
              zipcodes: Array.from(
                new Set(
                  item?.['Zip Code']
                    .split(',')
                    .map((zipcode: any) => zipcode.trim())
                    .filter((zipcode: any) => zipcode !== null && zipcode !== '')
                )
              ),
              type: 'UTILITY',
              id: uuid(),
            }
          }
          const emptyColumns: string[] = []
          const invalidZipCodes: string[] = []
          const utilityState: string[] = []
          const zipCodeRegex = /^\d{5}$/

          const columnName = Object.keys(results.data[0] || {})
          if (columnName.length === expectedHeaders.length) {
            expectedHeaders.forEach((header, index) => {
              if (columnName[index] !== header) {
                canUpload = false
                setCsvValidationMsg('Headers are mismatched. Please upload a valid CSV format')
                setBtnDisabled && setBtnDisabled(true)
              }
              else{
                results.data.forEach((item: any, index: number) => {
                  const UtilityState = state.find(
                    (state) => state.value.toLowerCase() === item?.['Utility State']?.toLowerCase()
                  )
      
                  if (!UtilityState && item['Utility State'].trim() !== '') {
                    utilityState.push(`${index + 1}`)
                  }
                  requiredColumns.forEach((col: string) => {
                    if (!item[col] || item[col].trim() === '') {
                      if (!emptyColumns.includes(col)) {
                        emptyColumns.push(col)
                      }
                    }
                  })
      
                  const zipCodes = item['Zip Code']
                    ? item['Zip Code'].split(',').map((zip: string) => zip.trim())
                    : []
      
                  zipCodes.forEach((zip: string) => {
                    if (!zipCodeRegex.test(zip)) {
                      if (!invalidZipCodes.includes(`${index + 1}`)) {
                        invalidZipCodes.push(`${index + 1}`)
                      }
                    }
                  })
                })
              }
            })
          } else {
            canUpload = false
            setCsvValidationMsg('Please upload a valid format')
            setBtnDisabled && setBtnDisabled(true)
          }

         
          
          if (emptyColumns.length > 0) {
            setBtnDisabled && setBtnDisabled(true)
            setCsvValidationMsg(`${emptyColumns.join(', ')} cannot be empty `)
            canUpload = false
          }
          if (utilityState.length > 0) {
            setBtnDisabled && setBtnDisabled(true)
            setCsvValidationMsg(
              `Utility State has invalid characters at row ${utilityState.join(', ')}`
            )
            canUpload = false
          }
          if (invalidZipCodes.length > 0) {
            setBtnDisabled && setBtnDisabled(true)
            setCsvValidationMsg(
              `Zip Code has invalid characters at row ${invalidZipCodes.join(', ')}`
            )
            canUpload = false
          }

          if (canUpload) {
            const utilityData = results.data.map((item: any) => {
              return convertToUtilityDataFormat(item)
            })
            setUtilityData((prevData: any) => [...prevData, ...utilityData])

            setValidationMsg('')
            setCsvValidationMsg('')
            setUploadingMessage(true)
          }
        }}
        onUploadRejected={async (file: any) => {
          const tempError: any = file[0]?.errors[0]
          if (tempError.code === 'file-invalid-type') {
            setCsvValidationMsg('')
            setFileUploadErr(true)
          }
        }}
        config={{header: true, delimiter: ',', skipEmptyLines: true}}
      >
        {({getRootProps, acceptedFile, ProgressBar, getRemoveFileProps, Remove}: any) => (
          <>
            <div {...getRootProps()}>
              <>
                {acceptedFile ? (
                  <>
                    {uploadingMessage ? (
                      <div className='text-center'>
                        {!validationMsg && (
                          <label className='uploaded-label'>File uploaded successfully</label>
                        )}
                        {validationMsg && (
                          <>
                            <p className='mt-1 text-danger'>{validationMsg}</p>
                            <Stack gap={2} className='align-items-center justify-content-center'>
                              <img
                                src={uploadIcon}
                                alt=''
                                width='40'
                                height='40'
                                className='svg-icon svg-icon-1'
                              />
                            </Stack>
                            <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                              Upload CSV
                            </span>
                          </>
                        )}
                      </div>
                    ) : (
                      <>
                        <p className='mt-1 text-danger'>{csvValidationMsg}</p>
                        <Stack gap={2} className='align-items-center justify-content-center'>
                          <img
                            src={uploadIcon}
                            alt=''
                            width='40'
                            height='40'
                            className='svg-icon svg-icon-1'
                          />
                        </Stack>
                        <span className='text-muted fw-semibold text-muted d-block fs-7 text-center'>
                          Upload CSV
                        </span>
                        {fileUploadErr && (
                          <label className='uploaded-label err-label'>
                            Please upload the CSV file.
                          </label>
                        )}
                      </>
                    )}
                  </>
                ) : (
                  <>
                    <Stack gap={2} className='align-items-center justify-content-center'>
                      <img
                        src={uploadIcon}
                        alt=''
                        width='40'
                        height='40'
                        className='svg-icon svg-icon-1'
                      />
                      <span className='text-dark text-hover-primary fs-6'>
                        Drop files here or click to upload
                      </span>
                      <span className='text-muted fw-semibold text-muted d-block fs-7'>
                        Upload CSV
                      </span>
                      {!acceptedFile && fileUploadErr && (
                        <label className='uploaded-label err-label'>
                          Please upload the CSV file.
                        </label>
                      )}
                    </Stack>
                  </>
                )}
              </>
            </div>
          </>
        )}
      </CSVReader>
    </div>
  )
}

export default UploadUtilityCSV